import React from "react";
import { Box, Typography } from "@mui/material";

const ACHIEVEMENTS = [
  { emoji: "\u{1F3C6}", text: "Best Overall \u2014 HackDuke 2026" },
  { emoji: "\u{1F947}", text: "1st Place Catalyst for Care \u2014 UCLA Hacks 2026" },
  { emoji: "\u{1F3C6}", text: "Winner \u2014 HackHarvard 2025" },
  { emoji: "\u{1F3C6}", text: "Best Use of AI \u2014 HackIllinois 2026" },
  { emoji: "\u{1F949}", text: "3rd Place Agentverse \u2014 UCLA Hacks 2026" },
  { emoji: "\u{1F3C6}", text: "Winner \u2014 LA Hacks 2026" },
  { emoji: "\u{1F393}", text: "Cum Laude \u2014 University at Buffalo" },
  { emoji: "\u{2B50}", text: "Dean\u0027s List (2x) \u2014 UB" },
];

const AchievementMarquee = () => {
  // Double the items for seamless loop
  const items = [...ACHIEVEMENTS, ...ACHIEVEMENTS];

  return (
    <Box
      sx={{
        overflow: "hidden",
        py: 2,
        borderTop: "1px solid rgba(124, 58, 237, 0.15)",
        borderBottom: "1px solid rgba(124, 58, 237, 0.15)",
        background:
          "linear-gradient(90deg, rgba(124,58,237,0.05) 0%, rgba(59,130,246,0.05) 50%, rgba(124,58,237,0.05) 100%)",
        position: "relative",
        "&::before, &::after": {
          content: '""',
          position: "absolute",
          top: 0,
          bottom: 0,
          width: "80px",
          zIndex: 2,
          pointerEvents: "none",
        },
        "&::before": {
          left: 0,
          background:
            "linear-gradient(90deg, #0A0A0F 0%, transparent 100%)",
        },
        "&::after": {
          right: 0,
          background:
            "linear-gradient(270deg, #0A0A0F 0%, transparent 100%)",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          whiteSpace: "nowrap",
          animation: "marqueeScroll 40s linear infinite",
          "@keyframes marqueeScroll": {
            "0%": { transform: "translateX(0)" },
            "100%": { transform: "translateX(-50%)" },
          },
          "&:hover": {
            animationPlayState: "paused",
          },
        }}
      >
        {items.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 1,
              px: 3,
              flexShrink: 0,
            }}
          >
            <Typography
              component="span"
              sx={{ fontSize: "1.1rem", lineHeight: 1 }}
            >
              {item.emoji}
            </Typography>
            <Typography
              component="span"
              sx={{
                fontSize: "0.85rem",
                fontWeight: 500,
                color: "rgba(255,255,255,0.7)",
                letterSpacing: "0.02em",
              }}
            >
              {item.text}
            </Typography>
            <Typography
              component="span"
              sx={{
                color: "rgba(124,58,237,0.3)",
                mx: 1,
                fontSize: "0.7rem",
              }}
            >
              {"\u25C6"}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default AchievementMarquee;
